import { ProspectTemplateHome } from '../../templates';

import { staticContent } from '../../data/seja-um-profissional';

const PageSejaUmProfissionalHome = (props) => (
  <ProspectTemplateHome {...props} />
);

const getStaticPropsHandler = async () => {
  return {
    props: {
      staticContent,
    },
  };
};

export const getStaticProps = getStaticPropsHandler;

export default PageSejaUmProfissionalHome;
